export const EthNetwork = process.env.NEXT_PUBLIC_ETH_NETWORK;

export const EthNetworks = {
  Mainnet: 1,
  Ropsten: 3,
  Rinkeby: 4,
  Goerli: 5,
  1: 'Mainnet',
  3: 'Ropsten',
  4: 'Rinkeby',
  5: 'Goerli',
};
